export const scrollToSectionWithOffset = (
  selector: string,
  offset: number = 50
): void => {
  // Function to perform the scroll with offset
  const performScroll = (element: HTMLElement) => {
    const elementTop = element.getBoundingClientRect().top;
    const elementPosition = elementTop + window.scrollY;
    const offsetPosition = Math.max(0, elementPosition - offset);

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  };

  // Try to find the element
  let section = document.getElementById(selector);
  
  // If not found, try querySelector as fallback
  if (!section) {
    section = document.querySelector(`#${selector}`) as HTMLElement;
  }
  
  if (section) {
    // Use requestAnimationFrame to ensure layout is calculated
    requestAnimationFrame(() => {
      performScroll(section!);
    });
  } else {
    // If element not found, retry after a delay (for lazy-loaded content)
    let retryCount = 0;
    const maxRetries = 20; // 20 * 50ms = 1 second
    
    const retryInterval = setInterval(() => {
      retryCount++;
      section = document.getElementById(selector);
      if (!section) {
        section = document.querySelector(`#${selector}`) as HTMLElement;
      }
      
      if (section) {
        clearInterval(retryInterval);
        requestAnimationFrame(() => {
          performScroll(section!);
        });
      } else if (retryCount >= maxRetries) {
        clearInterval(retryInterval);
        console.warn(`Section with id "${selector}" not found after ${maxRetries} retries`);
      }
    }, 50);
  }
};
